export const move = (input, from, to) => {
  const newInput = [...input];
  const elm = newInput.splice(from, 1)[0];
  newInput.splice(to, 0, elm);
  return newInput;
};
